import { useReadingProgress } from "@/hooks/useReadingProgress";
import React from "react";

type ScrollBarProps = {
  contentRef: React.MutableRefObject<HTMLDivElement | null>;
};

export const ScrollBar: React.FC<ScrollBarProps> = ({ contentRef }) => {
  const completion = useReadingProgress(contentRef);

  return (
    <div className="sticky top-0 z-[51] mx-auto h-1 w-full bg-gray-200">
      <span className="absolute left-0 top-0 h-1 bg-orange" style={{ width: `${completion}%` }} />
    </div>
  );
};
